import { proxy } from "valtio";

export const enforceTitle = proxy<{
  title: string | null;
}>({
  title: null,
});
